
import { Component, Prop, Vue } from 'vue-property-decorator';
import WPXForm, { WPXFormValue } from '@/components/templates/WPXForm';
import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { Treeview } from '@/views/interfaces/vuetify/treeview.interface';
import { FolderTreeBranch } from '@/components/file-browser/FileBrowser.vue';

export class AddFileForm {
  public file: File;
  public private: boolean = false;
  public folderId: string | number;

  public rules: { [key: string]: FormValidationFunction[] } = {
    file: [
      (v) => !!v || 'File is required',
    ],
  };
}

@Component({
  components: { WPXForm },
})
export default class AddFile extends Vue {
  @Prop({ required: true })
  private readonly folder: FolderTreeBranch

  private form: WPXFormValue<AddFileForm> = new WPXFormValue(AddFileForm);

  private mounted(): void {
    this.form.data.folderId = this.folder.id;
    this.form.data.private = this.folder.folder.private;
  }

  private addFile(): void {
    this.$emit('upload-file', this.form.data);
  }
}

